// Tiny React hook over the existing ping-outbox subscription. Kept separate
// from ping-outbox.ts so we don't risk regressions in the well-tested outbox
// drain logic when only the UI needs a new subscriber shape.
import { useSyncExternalStore } from "react";
import { getOutboxStats, subscribeOutbox, type OutboxStats } from "./ping-outbox";

export function useOutboxStats(): OutboxStats {
  return useSyncExternalStore(subscribeOutbox, getOutboxStats, getOutboxStats);
}
